import React from 'react';
import { Translate } from 'react-localize-redux';
import css from './ExternalOrgEmptyState.css';

function PartnerEmptyState() {
    return (
        <div className={css.container}>
            <div className={css.title}>
                <Translate id="STATIC.PAGES.PARTNERS_PORTAL.EMPTY_STATE_TITLE" />
            </div>
            <div className={css.description}>
                <Translate id="STATIC.PAGES.PARTNERS_PORTAL.EMPTY_STATE_PARTNER_DESCRIPTION" />
            </div>
        </div>
    );
}

export default PartnerEmptyState;
